export type Image = {
  src: string;
  alt: string;
};

export type Video = {
  src: string;
  alt: string;
};

export type MediaAsset = Image | Video;

export type TranslatableComponent<Assets, Labels> = {
  assets: {
    [Property in keyof Assets]: MediaAsset | Array<MediaAsset>;
  };
  labels: {
    [Property in keyof Labels]: string;
  };
};

export type Tag = {
  label: string;
  value: string;
};

export enum TagType {
  BLOG = "blog",
  PRESS_RELEASE = "press_release",
}

declare global {
  interface Window {
    dataLayer: any[];
  }
}
